function ComingSoon() {
  return (
    <div className="stat-coming-soon">
      <span>Coming Soon</span>
    </div>
  )
}
export default ComingSoon
